import React from 'react';
import { Button } from '@/components/ui/button'; // Assuming you have a Button component
import { useLoginModal } from '@/contexts/LoginModalContext';

const SignupBanner: React.FC = () => {
  const { openLoginModal } = useLoginModal();

  const handleOpenSignupModal = () => {
    openLoginModal();
  };

  // const today = new Date();
  // const currentMonth = today.getMonth() + 1; // JavaScript months are 0-indexed
  // const currentDate = today.getDate();
  // const dateString = `(${currentMonth}월 ${currentDate}일 기준)`;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gradient-to-r from-purple-600 to-indigo-600 text-white p-4 text-center shadow-lg z-50">
      <div className="container mx-auto flex flex-col sm:flex-row justify-between items-center">
      <div className="text-center sm:text-left">
          <p className="mb-1">
            간편 로그인으로 1초 회원가입하고 <strong className="font-bold">모든 기능</strong>을 이용해보세요!
          </p>
          <p className="text-sm">
            PC 환경을 추천드립니다.
          </p>
        </div>
        <Button
          variant="outline"
          className="bg-white text-brand-primary hover:bg-brand-light hover:text-brand-primary mt-2 sm:mt-0"
          onClick={handleOpenSignupModal}
        >
          1초 회원가입하기
        </Button>
      </div>
    </div>
  );
};

export default SignupBanner;